import { Injectable } from '@angular/core';
import { HttpClient, HttpHandler, HttpEvent, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

	constructor(private http: HttpClient, private router: Router, private authService: AuthenticationService) { }

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		// Obtén el token de autorización del almacenamiento local o de donde lo almacenes
		const authToken = localStorage.getItem('jwt'); // Asegúrate de tener un nombre de clave adecuado
		if (request.url.includes('login')) {
			return next.handle(request);
		} else if (request.url.includes('edxgt')) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer NDM0MzA3NzU=`
				}
			});
		} else if (request.url.includes('role/user')) {
			if (authToken) {
				request = request.clone({
					setHeaders: {
						Authorization: `Bearer ${authToken}`,
					}
				});
			}
		} else {
			if (request.url.includes(environment.api)) {
				if (authToken) {
					if (this.authService.getCurrentCompanyId()) {
						request = request.clone({
							setHeaders: {
								Authorization: `Bearer ${authToken}`,
								"inin-company": this.authService.getCurrentCompanyId(),
								// 'Access-Control-Allow-Origin': '*',  // Puedes ajustar esto según tus necesidades
								// 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
								// 'Access-Control-Allow-Headers': 'Content-Type, X-Requested-With',
								"ININ-Company": this.authService.getCurrentCompanyId(),
							}
						});
					} else {
						request = request.clone({
							setHeaders: {
								Authorization: `Bearer ${authToken}`
							}
						});
					}
				}
			} else {
				return next.handle(request);
			}

		}



		// Continúa con la solicitud modificada
		return next.handle(request);
	}

	supports(method: string, url: string): boolean {
		// Retornar true para que el interceptor se aplique a todas las solicitudes
		return true;
	}
}